import{collection, addDoc, setDoc, doc, getDoc, getDocs,query, where, deleteDoc, serverTimestamp} from "firebase/firestore";
import { logEvent } from "./analytics";

//create a new resume or update an existing one
export async function saveResume(db, uid, { id, title, data, template })
{
  const resumeDocument = {ownerUid: uid,title,data,template,updatedAt: serverTimestamp(),};

  if (id)
  {
    // UPDATE existing resume
    await setDoc(doc(db, "resumes", id), resumeDocument, { merge: true });
    await logEvent(db, "resume_updated", uid, {resumeId: id,template,});
    return id;
  }

  // CREATE new resume
  const ref = await addDoc(collection(db, "resumes"), resumeDocument);
  await logEvent(db, "resume_created", uid, {resumeId: ref.id,template,});
  return ref.id;
}



//list all resumes
export async function listResumes(db, uid)
{
  const q = query(collection(db, "resumes"),where("ownerUid", "==", uid));//query
  const snap = await getDocs(q);
  const rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));//turning the docs into objects

  return rows.sort((a, b) => {const ta = a?.updatedAt?.seconds || 0;const tb = b?.updatedAt?.seconds || 0;return tb - ta;});//sort newes first
}

//load resume by id
export async function loadResume(db, id)
{
  const snap = await getDoc(doc(db, "resumes", id));
  if (!snap.exists()) return null;//doesnt exist
  return{ id: snap.id, ...snap.data() };
}

// Delete a resume by id
export async function deleteResume(db, id)
{
  await deleteDoc(doc(db, "resumes", id));
}
